export const allowedToSelfWithdraw = (shiftStartTimeMs, withdrawalAllowedTimeMs) => {
    const timeUntilShiftStart = shiftStartTimeMs - Date.now();
    return timeUntilShiftStart > withdrawalAllowedTimeMs;
};
